/*
payment/bonus/view_submitbtn

import view_submitbtn from ...

-- supply wrapper and callback to invoke on click --
view_submitbtn.init({cb, wrap:'domElm'});

 --delete button and eventhandlers --
 view_submitbtn.close();
*/

import core from '../../common/lib/core.js';

const classnameOpen = 'u-show';
const classnameClose = 'u-hide';
const create = core.create;
let buttonText = 'submit texkey';
let theCallback = function theCallback() {
	console.info('view_submitbtn:18: no callback provided');
};
let elements = {};

function createSubmit(txt) {
	const elm = create({
		type: 'button',
		class: 'js-event-filter-payment-submit payment__submit-deposit btn u-b-radius'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createSpinner() {
	const elm = create({
		type: 'div',
		class: 'spinner u-hide'
	});

	return elm;
}

function showSpinner(bool) {
	if (bool) {
		core.removeClass(elements.spinner, classnameClose);
	} else {
		core.addClass(elements.spinner, classnameClose);
	}
}

function changeText(newTxt) {
	if (elements.submit) {
		elements.submit.innerHTML = newTxt;
	} else {
		console.error('submit button does not exist');
	}
}

function assembleElements() {
	elements.submit = (elements.submit || createSubmit(buttonText));
	elements.spinner = createSpinner();
	elements.submit.appendChild(elements.spinner);
	elements.wrap.appendChild(elements.submit);
}

function deleteAllElements() {
	elements = core.deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys'], 'view_submitbtn:39');
}

function showWrap() {
	document.documentElement.classList.add('overlay--open');

	if (elements && elements.wrap) {
		if (core.hasClass(elements.wrap, classnameClose)) {
			core.removeClass(elements.wrap, classnameClose);
		}
		if (!core.hasClass(elements.wrap, classnameOpen)) {
			core.addClass(elements.wrap, classnameOpen);
		}
	}
}

function hideWrap() {
	document.documentElement.classList.remove('overlay--open');

	if (core.hasClass(elements.wrap, classnameOpen)) {
		core.removeClass(elements.wrap, classnameOpen);
	}
	if (!core.hasClass(elements.wrap, classnameClose)) {
		core.addClass(elements.wrap, classnameClose);
	}
}

function clickBtnHandler(e) {
	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		theCallback();
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	core.handle(e, '.js-event-filter-payment-submit', cb, true);
}

function addListeners() {
	core.addListener(elements.wrap, 'click', clickBtnHandler);
}

function removeListeners() {
	if (elements && elements.wrap) {
		core.removeListener(elements.wrap, 'click', clickBtnHandler);
	}
}

export default {
	init(p) {
		elements.wrap = core.getElementIfValid(p, 'wrap', 'view_submitbtn:90');
		theCallback = (p.cb || theCallback);
		buttonText = (p.buttonText || buttonText);
		assembleElements();
		addListeners();
		/* the button is displayed by default,
		 hide it actively from .hide() */
		showWrap();
	},
	show() {
		showWrap();
	},
	hide() {
		hideWrap();
	},
	close() {
		deleteAllElements();
		removeListeners();
	},
	changeText,
	showSpinner
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/bonus/lib/view-submitbtn.js